// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {ThemeProvider} from 'uikit';
import {REACT_ROOT_ID} from '@pub/constants.js';
import Router from '@pub/routers/router_light.js';
import {handle_scheduled_events} from '@pub/utils/analytics.js';
import {Suspense} from '@pub/lazy.js';
import 'normalize.css';
import '@pub/css/global.less';

const container = document.getElementById(REACT_ROOT_ID);

function Root(){
    return <BrowserRouter>
      <ThemeProvider>
        <Suspense>
          <Router/>
        </Suspense>
      </ThemeProvider>
    </BrowserRouter>;
}

handle_scheduled_events();

const root = createRoot(container);
root.render(<Root/>);
